export default {"src":"/_next/static/media/helixtap.86b2d09d.svg","height":36,"width":19,"blurWidth":0,"blurHeight":0};